import React, { createContext, useContext } from 'react'

export const DRAWER_WIDTH_OPENED = 240
export const DRAWER_WIDTH_CLOSED = 65 

const DrawerContext = createContext({
  open: true,
  isLargeScreen: true,
  drawerWidth: DRAWER_WIDTH_OPENED,
})

export function DrawerProvider({ open, isLargeScreen, children }) {
  const drawerWidth = isLargeScreen ? (open ? DRAWER_WIDTH_OPENED : DRAWER_WIDTH_CLOSED) : 0

  return (
    <DrawerContext.Provider value={{ open, isLargeScreen, drawerWidth }}>
      {children}
    </DrawerContext.Provider>
  )
}

export function useDrawerState() {
  return useContext(DrawerContext)
}
